import React from 'react'

import { useClientSide } from '../../hooks/useClientSide'
import ModalAd from '../Common/ModalAd'
import ContactForm from '../contact-form'
import { useTranslations } from '../../hooks/use-translations'
import { LocalesEnum } from '../../types/locales.enum'
import { getLastDayOfMonth } from './helper'

const StartForFreePopUp: React.FC = () => {
  const [showModal, setShowModal] = React.useState(false)
  const [showContactForm, setShowContactForm] = React.useState(false)
  const [confirm, setConfirm] = React.useState(false)
  const timeoutAction = useClientSide(3000)
  const { t, locale } = useTranslations()
  const lastDayOfOffer = getLastDayOfMonth(locale)

  React.useEffect(() => {
    if (localStorage.getItem('startForFreeConfirm')) {
      setConfirm(true)
    }
  }, [])

  React.useEffect(() => {
    function handleMouseLeave() {
      setShowModal(true)
      setConfirm(true)
      localStorage.setItem('startForFreeConfirm', 'true')
    }

    if (typeof document !== 'undefined' && timeoutAction && !confirm) {
      document.addEventListener('mouseleave', handleMouseLeave)
      document.addEventListener('visibilitychange', handleMouseLeave)
      return () => {
        document.removeEventListener('mouseleave', handleMouseLeave)
        document.removeEventListener('visibilitychange', handleMouseLeave)
      }
    }
  }, [confirm, timeoutAction])

  return (
    <>
      {showModal && (
        <ModalAd
          titleModal={t('offer_title_modal')}
          titleText={t('offer_title_text')}
          description={t('offer_description')}
          buttonText={t('offer_button_text')}
          subText={`${t('offer_sub_text_1')}${lastDayOfOffer}${t(
            'offer_sub_text_2'
          )}`}
          highlightDescriptionWordsByIdx={
            locale === LocalesEnum.Us
              ? [1, 2, 3, 8, 10, 13, 14, 18]
              : locale === LocalesEnum.Es
              ? [1, 2, 3, 9, 10, 11, 13, 14, 19]
              : []
          }
          classNameHighlightText="boldText"
          onClose={() => {
            setShowModal(false)
          }}
          onConfirm={() => {
            setShowModal(false)
            setShowContactForm(true)
          }}
        />
      )}
      {showContactForm && (
        <ContactForm
          onClose={() => setShowContactForm(false)}
          title={t('offer_title_contact_form')}
          requestType="Buy"
        />
      )}
    </>
  )
}

export default StartForFreePopUp
